import axios from "axios";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};

export const getAllActivityTypes = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "activityType/",
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const getActivityType = async (activityTypeId) => {
  const response = await axios.get(
    process.env.REACT_APP_API_URL + `activityType/${activityTypeId}`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const createActivityType = async (body) => {
  const response = await axios.post(
    process.env.REACT_APP_API_URL + "activityType",
    body,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const updateActivityType = async (body) => {
  const response = await axios.put(
    process.env.REACT_APP_API_URL + "activityType/",
    body,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const deleteActivityType = async (activityTypeId) => {
  const response = await axios.delete(
    process.env.REACT_APP_API_URL + `activityType/${activityTypeId}`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const deleteMultipleActivityTypes = async (ids) => {
  const response = await axios.delete(
    process.env.REACT_APP_API_URL + "activityType/multiple",
    {
      headers: getAuthHeaders(),
      data: { ids },
    }
  );
  return response.data;
};

export const mapLegacyActivityNamesToIds = (names, activityTypes) => {
  if (!names?.length || !activityTypes?.length) {
    return [];
  }
  return names
    .map(
      (name) =>
        activityTypes.find((activityType) => activityType.activityName === name)
          ?.id
    )
    .filter(Boolean);
};

export const getActivityNamesFromIds = (ids, activityTypes) => {
  if (!ids?.length || !activityTypes?.length) {
    return [];
  }
  return ids
    .map(
      (id) =>
        activityTypes.find((activityType) => activityType.id === id)
          ?.activityName
    )
    .filter(Boolean);
};

export const normalizeRestrictionActivityTypes = (
  activityTypeValues,
  allActivityTypes
) => {
  if (!activityTypeValues?.length || !allActivityTypes?.length) {
    return activityTypeValues || [];
  }

  const isAlreadyIds = activityTypeValues.every((value) =>
    allActivityTypes.some((activityType) => activityType.id === value)
  );

  if (isAlreadyIds) {
    return activityTypeValues;
  }

  return mapLegacyActivityNamesToIds(activityTypeValues, allActivityTypes);
};

export const parseLocationActivityTypeIds = (locationData, allActivityTypes) => {
  if (locationData?.activityTypeLocationPopulated?.length) {
    return locationData.activityTypeLocationPopulated.map((item) => item.id);
  }

  if (locationData?.activityTypeLocation?.length) {
    return locationData.activityTypeLocation;
  }

  return mapLegacyActivityNamesToIds(
    locationData?.activityType,
    allActivityTypes
  );
};

export const buildLocationActivityTypePayload = (selectedIds, allActivityTypes) => ({
  activityTypeLocation: selectedIds,
  activityType: getActivityNamesFromIds(selectedIds, allActivityTypes),
});

export const parseRestrictionsUserFromGet = (
  restrictionsUser,
  legacyRestrictions,
  allActivityTypes
) => {
  const source = restrictionsUser?.length
    ? restrictionsUser
    : legacyRestrictions;

  if (!source?.length) {
    return [];
  }

  return source.map((restriction) => {
    let activityTypeRestriction = [];

    if (restriction.activityTypeRestrictionPopulated?.length) {
      activityTypeRestriction = restriction.activityTypeRestrictionPopulated.map(
        (item) => item.id
      );
    } else if (restriction.activityTypeRestriction?.length) {
      activityTypeRestriction = restriction.activityTypeRestriction;
    } else if (restriction.activityTypes?.length) {
      activityTypeRestriction = normalizeRestrictionActivityTypes(
        restriction.activityTypes,
        allActivityTypes
      );
    }

    return {
      locationId: restriction.locationId || "",
      activityTypeRestriction,
    };
  });
};

export const buildRestrictionsUserForSave = (restrictions) =>
  (restrictions || []).map((restriction) => ({
    locationId: restriction.locationId,
    activityTypeRestriction: restriction.activityTypeRestriction || [],
  }));
